// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2Eq5k","rootSmall":"AddTileButton_rootSmall__1DGlx"};